import { getCurrentInstance } from "vue";

export const PrimeVueMenuServiceSymbol = Symbol();
let sharedMenuService = null;

export function setSharedMenuService(menuService) {
  sharedMenuService = menuService;
}

export function useMenuService() {
  if (sharedMenuService) {
    return sharedMenuService;
  }

  const instance = getCurrentInstance();
  const providedService =
    instance && instance.appContext && instance.appContext.provides
      ? instance.appContext.provides[PrimeVueMenuServiceSymbol]
      : null;

  if (providedService) {
    sharedMenuService = providedService;
    return providedService;
  }

  throw new Error("No PrimeVue MenuService provided!");
}
